/**
 * Utility to check if code is running in a browser environment
 */
const isBrowser =
    typeof window !== 'undefined' && typeof document !== 'undefined';

/**
 * Sets meta tag to instruct search engines not to index the page
 * @returns {HTMLMetaElement|null} The created meta element or null if execution failed
 */
export function setNoIndex() {
    if (!isBrowser) return null;

    try {
        const noIndexTag = document.createElement('meta');
        noIndexTag.name = 'robots';
        noIndexTag.content = 'noindex';

        document.head.appendChild(noIndexTag);
        return noIndexTag;
    } catch (e) {
        console.error('Failed to set noindex meta tag:', e);
        return null;
    }
}

/**
 * Sets favicon images based on provided favicon URL
 * @param {string} faviconImage - URL to the favicon image
 * @returns {boolean} Whether the operation succeeded
 */
export function setFavicon(faviconImage) {
    if (!isBrowser || !faviconImage) return false;

    try {
        const favicon = document.getElementById('favicon');
        if (favicon) {
            favicon.href = `${faviconImage}-/resize/32x32/`;
        }

        const appleFavicon = document.getElementById('apple-favicon');
        if (appleFavicon) {
            appleFavicon.href = `${faviconImage}-/resize/180x180/-/format/png/`;
        }

        return true;
    } catch (e) {
        console.error('Failed to set favicon:', e);
        return false;
    }
}
